
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 33.06 65.42"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 32.71a3.14 3.14 0 00.78 2.16l28.11 29.79a2.18 2.18 0 001.63.76 2.67 2.67 0 002.38-2 3.13 3.13 0 00-.66-3.09L6.17 32.71 32.24 5.07A3.12 3.12 0 0032.9 2a2.67 2.67 0 00-2.38-2 2.21 2.21 0 00-1.63.75L.78 30.56A3.11 3.11 0 000 32.71","fill":"#4fa2b7"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/globals/arrow_back.svg